import { Fragment } from "react";
import TooltipInline from "components/source/shared/tooltip-inline";
import PropTypes from "prop-types";
import ConciergeModal from "./concierge-modal";
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const propTypes = {
  isMobileViewport: PropTypes.bool,
};

const ConciergeNotification = ({ isMobileViewport }) => {
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const toggleVisibility = (e, isVisible) => {
    if (e) {
      e.preventDefault();
    }
    setIsTooltipOpen(isVisible);
  };

  const renderTooltip = () => {
    if (isMobileViewport) {
      return null;
    }
    return (
      <TooltipInline
        display={isTooltipOpen}
        align="center"
        position="top"
        className="tool-tip-content concierge-notification-tooltip">
        <p>
          By signing up for texts, you agree to receive recurring automated and personalized marketing text messages
          from Rent the Runway. Consent is not a condition of any purchase. Message frequency varies. Msg & data rates
          may apply. View Terms & Privacy.
        </p>
      </TooltipInline>
    );
  };

  const renderTooltipLink = () => {
    if (isMobileViewport) {
      return null;
    }
    return (
      <div
        className={"tooltip-link"}
        role="tooltip"
        onMouseOver={e => toggleVisibility(e, true)}
        onFocus={e => toggleVisibility(e, true)}
        onMouseOut={e => toggleVisibility(e, false)}
        onBlur={e => toggleVisibility(e, false)}>
        <span className="universal-underline-dashed">Text &lsquo;STYLE&rsquo;</span>
        {renderTooltip()}
      </div>
    );
  };

  const renderArrow = () => {
    if (!isMobileViewport) {
      return null;
    }
    return (
      <div className={"right-arrow"}>
        <svg viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.75 1L7.66789 7.91789C8.05842 8.30842 8.05842 8.94158 7.66789 9.33211L0.75 16.25"
            stroke="black"
            strokeLinecap="round"
          />
        </svg>
      </div>
    );
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const renderModal = () => {
    if (!isMobileViewport || !isModalOpen) {
      return null;
    }
    return <ConciergeModal isModalOpen={true} handleCloseModal={handleCloseModal} />;
  };

  const renderInnerContent = () => {
    const tooltipTitleText = isMobileViewport ? "Want help picking your shipment?" : "Want personal styling?";
    const tooltipSpanText = isMobileViewport
      ? "Tap to connect with our styling team"
      : " to 276\u201128 for 1:1 help picking shipments";
    const spanClass = isMobileViewport ? "tooltip-span mobile" : "tooltip-span";

    return (
      <Fragment>
        <img
          src="https://cdn.rtrcdn.com/assets/imgs/RTRConcierge_SpeechBubble-Icon2_20230927.svg"
          alt={"RTR Concierge Tip"}
        />
        <div className="tooltip-text">
          <span className={"tooltip-title"}>{tooltipTitleText}&nbsp;</span>
          {renderTooltipLink()}
          <span className={spanClass}>{tooltipSpanText}</span>
        </div>
        {renderArrow()}
      </Fragment>
    );
  };

  const notificationClassName = isMobileViewport ? "concierge-notification mobile" : "concierge-notification";

  return isMobileViewport ? (
    <>
      <button className={notificationClassName} data-test-id="concierge-instruction-button" onClick={showModal}>
        {renderInnerContent()}
      </button>
      {renderModal()}
    </>
  ) : (
    <>
      <div className={notificationClassName} data-test-id="concierge-instruction-display">
        {renderInnerContent()}
      </div>
      {renderModal()}
    </>
  );
};

ConciergeNotification.propTypes = propTypes;
export default ConciergeNotification;
